import { render, staticRenderFns } from "./dingzhiOrder.vue?vue&type=template&id=1e62cbc1&scoped=true&"
import script from "./dingzhiOrder.vue?vue&type=script&lang=js&"
export * from "./dingzhiOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62cbc1",
  null
  
)

export default component.exports